import React, { useEffect, useState } from "react";
import ElementPage from "../Elements";
import { useTranslation } from "react-i18next";
import {
  getOurServiceList,
  getOurServiceByServiceID,
  getItemCategoryActiveList,
  getProductActiveListByCategoryID,
  applyProduct_InquiryDetails,
} from "./MeldiDhamCRUD";

import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
import { NavLink, useParams } from "react-router-dom";

const ServicesListPage = () => {
  const { t, i18n } = useTranslation();
  const { id } = useParams();

  // -------------------- STATES -----------------------
  const [loading, setLoading] = useState(true);
  const [serviceList, setServiceList] = useState([]);

  const [showModal, setShowModal] = useState(false);
  const [selectedServiceID, setSelectedServiceID] = useState(0);
  const pathUrl = process.env.REACT_APP_API_URL;
  const [formData, setFormData] = React.useState({
    businessID: 0,
    ourServiceID: 0,
    serviceName: "",
    serviceName_GJ: "",
    serviceName_HN: "",
    servicePhotoPath: "",
    sortDescription: "",
    description: "",
    isActive: true,
  });
  // -------------------- FETCH ALL SERVICES -----------------------
  useEffect(() => {
    loadServiceDetails(id);
    getDataOurServiceList();
  }, [id]);

  // -------------------- FETCH SERVICE BY ID -----------------------
  const loadServiceDetails = async (ourServiceID) => {
    setLoading(true);
    try {
      const res = await getOurServiceByServiceID(ourServiceID);
      if (res.data.isSuccess) {
        setFormData(res.data);
        setSelectedServiceID(ourServiceID);
      } else {
        toast.error(res.data.message);
      }
    } catch (err) {
      toast.error("Error loading service details.");
    } finally {
      setLoading(false);
    }
  };

  // -------------------- LOCALIZATION HELPER -----------------------
  const getLocalized = (item, field) => {
    if (!item) return "";
    const lang = i18n.language;
    if (lang === "gu") return item[`${field}_GJ`] || item[field];
    if (lang === "hi") return item[`${field}_HN`] || item[field];
    return item[field]; // default EN
  };

  // -------------------- OurService List -----------------------
  const getDataOurServiceList = async () => {
    try {
      const res = await getOurServiceList();
      if (res.data.isSuccess) {
        setServiceList(res.data.responseObject);
      }
    } catch (err) {
      console.error("Category error:", err);
    }
  };

  // const loadProducts = async (categoryID) => {
  //   try {
  //     const res = await getProductActiveListByCategoryID(categoryID);
  //     if (res.data.isSuccess) {
  //       setProducts(res.data.responseObject);
  //     }
  //   } catch (err) {
  //     console.error("Product error:", err);
  //   }
  // };

  // -------------------- INQUIRY FORM -----------------------
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  const handleOpenModal = () => {
    reset();
    setShowModal(true);
  };

  const handleSubmitInquiry = async (data) => {
    try {
      const res = await applyProduct_InquiryDetails(
        data.name,
        "",
        data.contact,
        data.message,
        "192.168.0.1",
        data.terms,
        1,
        data.ourServiceID,
        2,
        0,
        0,
      );

      if (res.data.isSuccess) {
        toast.success(res.data.message);
        reset();
        setShowModal(false);
      } else {
        toast.error(res.data.message);
      }
    } catch (err) {
      toast.error("Error submitting inquiry.");
    }
  };

  return (
    <>
      {/* <Row>
        <Col md={3}>
          <div className="list-group shadow-sm">
            {serviceList.map((srv) => (
              <button
                key={srv.ourServiceID}
                className={`list-group-item list-group-item-action ${
                  selectedServiceID === srv.ourServiceID ? "active" : ""
                }`}
                onClick={() => loadServiceDetails(srv.ourServiceID)}
              >
                {getLocalized(srv, "serviceName")}
              </button>
            ))}
          </div>
        </Col>

        ------------------- SERVICE DETAILS ---------------------
        <Col md={12} className="px-4">
          {loading || !formData ? (
            <div className="text-center py-5">Loading...</div>
          ) : (
            <>
              <div
                style={{ width: "100%", height: "400px", overflow: "hidden" }}
              >
                <img
                  src={pathUrl + formData.servicePhotoPath}
                  alt=""
                  className="w-100 h-100"
                  style={{ objectFit: "cover", borderRadius: "8px" }}
                />
              </div>

              Title + Button
              <div className="mt-3 d-flex justify-content-between align-items-center">
                <h3>{getLocalized(formData, "serviceName")}</h3>

                <Button
                  style={{ background: "#31572C", border: "none" }}
                  onClick={handleOpenModal}
                >
                  Inquiry Now
                </Button>
              </div>

              Short Description
              <p
                className="mt-3"
                dangerouslySetInnerHTML={{
                  __html: getLocalized(formData, "sortDescription"),
                }}
              ></p>

              Full Description
              <p
                dangerouslySetInnerHTML={{
                  __html: getLocalized(formData, "description"),
                }}
              ></p>
            </>
          )}
        </Col>
      </Row> */}{" "}
      {loading ? (
        <div className="flex flex-col items-center justify-center min-h-[300px] text-center">
          <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-blue-500"></div>
          <p className="mt-2 text-gray-600">Loading services...</p>
        </div>
      ) : formData === 0 ? (
        <tr
          className={
            formData === 0 && loading === false
              ? "gradient-background2 h-100"
              : "d-none"
          }
        >
          <td colSpan={3}>
            <div className="d-flex justify-content-center mt-3 pt-3 fs-5 font-serif">
              No data found
            </div>
            <div className="d-flex justify-content-center mt-2 pt-2">
              <img
                className="w-25"
                src={`url(/assets/logo/15-dark.png)`}
                alt=""
              />
            </div>
          </td>
        </tr>
      ) : (
        <>
          {" "}
          <div
            style={{
              position: "relative",
              display: "inline-block",
              width: "100%",
              height: "450px", // reduced height
              overflow: "hidden", // keeps image contained
            }}
          >
            <img
              src={pathUrl + formData.servicePhotoPath}
              alt="security img"
              className="w-full h-full"
              style={{
                display: "block",
                // borderRadius: "2px",
                objectFit: "cover", // keeps aspect ratio
              }}
            />

            {/* Overlay container for text + button */}
            <div
              style={{
                position: "absolute",
                bottom: "80px",
                left: "50%",
                transform: "translateX(-50%)",
                textAlign: "center",
              }}
            >
              <h3
                style={{
                  fontWeight: "bolder",
                  fontSize: "1.7rem",
                  backgroundColor: "rgba(255, 255, 255, 0.7)", // semi-transparent
                  padding: "20px 15px",
                  borderRadius: "6px",
                  // letterSpacing: "0.1rem",
                  lineHeight: "1.3",
                  textTransform: "uppercase",
                }}
                className="text-[#31572C] font-serif"
              >
                {getLocalized(formData, "serviceName")}
              </h3>
            </div>
          </div>
          <div
            className="container"
            role="navigation"
            aria-label="Breadcrumb"
            // style={{ marginTop: "var(--header-height)" }}
          >
            {" "}
            <div
              className="d-flex align-items-center gap-2 py-0  ms-1 row mb-5 col-lg-12 col-md-12 col-sm-12 bg-light shadow mt-product bdr-1 bdr-solid bdr-gray-light"
              style={{ height: "50px" }}
            >
              <span>
                <NavLink
                  to="/"
                  className="site-button"
                  style={{ fontSize: "17px", color: "#000000" }}
                >
                  {t("menu.home")} &gt;&gt;{" "}
                </NavLink>

                <span className="text-[#4c934c]" style={{ fontSize: "17px" }}>
                  {getLocalized(formData, "serviceName")}
                </span>
              </span>
            </div>
          </div>
          <section className="bg-white px-4 mb-5 text-center">
            <div className="container py-3">
              <h6
                className="fs-6 mr-5 text-gray-900 font-serif"
                style={{
                  // fontWeight: "450",
                  textAlign: "justify",
                }}
                dangerouslySetInnerHTML={{
                  __html: getLocalized(formData, "sortDescription"),
                }}
              ></h6>{" "}
              <p
                className="fs-6 mr-5 text-gray-900 font-serif"
                style={{
                  // fontWeight: "450",
                  textAlign: "justify",
                }}
                dangerouslySetInnerHTML={{
                  __html: getLocalized(formData, "description"),
                }}
              />
              <Button
                style={{
                  backgroundColor: "#31572C",
                  border: "none",
                  color: "white",
                }}
                size="md"
                className="mt-3 fw-bold contact-justify-center"
                onClick={() => handleOpenModal(formData.ourServiceID)}
              >
                Inquiry Now
              </Button>
              {/* </div>{" "} */}
              {/* <div className="border w-full max-w-[500px] mt-5 mx-2 mt-2 flex flex-col sm:flex-row items-center p-4 gap-4 shadow-sm">
                //  Left: Brochure Image
                <div className="w-full sm:w-1/3">
                  <img
                    src={pathUrl + formData.servicePhotoPath} // Replace with your image path
                    alt="img"
                    className="w-full h-auto object-cover"
                  />
                </div>

                // Right: Title & Button
                <div className="items-center justify-content-center text-center sm:text-left sm:items-start gap-4 w-full sm:w-2/3">
                  <h3 className="font-medium text-base">
                    {formData.serviceName}
                  </h3>
                  <button className="px-4 py-2 border rounded hover:bg-gray-100 transition">
                    Download
                  </button>
                 
                </div>
              </div> */}
            </div>
          </section>
        </>
      )}
      {/* ------------------- INQUIRY MODAL --------------------- */}
      <Modal show={showModal} onHide={() => setShowModal(false)} centered>
        <Form onSubmit={handleSubmit(handleSubmitInquiry)}>
          <Modal.Header closeButton>
            <Modal.Title className="text-yellow-500">
              Product Inquiry
            </Modal.Title>
          </Modal.Header>

          <Modal.Body>
            {/* <Form.Group>
              <Form.Select
                {...register("productCategoryID", { required: "Required" })}
                onChange={(e) => loadProducts(e.target.value)}
              >
                <option value="">Select Category</option>
                {categoryData.map((c) => (
                  <option key={c.productCategoryID} value={c.productCategoryID}>
                    {getLocalized(c, "productCategoryName")}
                  </option>
                ))}
              </Form.Select>
            </Form.Group> */}

            <Form.Group className="mt-3">
              {/* <Form.Label>Product</Form.Label> */}
              <Form.Select
                {...register("ourServiceID", { required: "Required" })}
                value={formData.ourServiceID}
                onChange={(e) => {
                  const selectedSerId = Number(e.target.value);
                  setFormData((prev) => ({
                    ...prev,
                    ourServiceID: selectedSerId,
                  }));
                }}
                required
              >
                <option value="">Select Service</option>
                {serviceList.map((p) => (
                  <option key={p.ourServiceID} value={p.ourServiceID}>
                    {getLocalized(p, "serviceName")}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>

            <Form.Group className="mt-3">
              <Form.Control
                placeholder="Your Name"
                {...register("name", { required: "Required" })}
              />
            </Form.Group>

            <Form.Group className="mt-3">
              <Form.Control
                placeholder="Contact Number"
                maxLength={10}
                {...register("contact", { required: "Required" })}
              />
            </Form.Group>

            <Form.Group className="mt-3">
              <Form.Control
                as="textarea"
                rows={4}
                placeholder="Message"
                {...register("message", { required: "Required" })}
              />
            </Form.Group>

            <Form.Group className="mt-3">
              <Form.Check
                type="checkbox"
                label="Agree to terms"
                {...register("terms", { required: "Required" })}
              />
            </Form.Group>
          </Modal.Body>

          <Modal.Footer>
            <Button
              type="submit"
              style={{ background: "#31572C", color: "white", border: 0 }}
            >
              Submit
            </Button>

            <Button
              className="text-secondary btn btn-light text-dark"
              onClick={() => setShowModal(false)}
            >
              Cancel
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
      <ElementPage />
    </>
  );
};

export default ServicesListPage;
